import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Dropdown } from 'core-components/library/dropdown'
import { selectWidgets } from 'core-components/sitebuilder/store/selectors/selectWidgets'
import { BaseCrud, Static } from 'core-components/types'

interface IGroupFilterSelector {
  value: string
  onChange: (newValue: string) => void
}

export const GroupFilterSelector = ({ value, onChange }: IGroupFilterSelector) => {
  const widgets = useSelector(selectWidgets)

  const source = useMemo(() => {
    const uniqGroups = new Set([...widgets.map((w) => w.group).filter(Boolean)])
    const groupsData = [...uniqGroups].map((el) => ({ key: el, label: el }))
    return new BaseCrud({
      fetcher: new Static(groupsData),
      keyField: 'key',
      defaultPaging: {
        page: 0,
        pageSize: groupsData.length,
      },
    })
  }, [widgets])

  return (
    <Dropdown
      classes={{ controlClasses: { root: 'margin-top-sm' } }}
      label={'Group name'}
      caption="label"
      source={source}
      value={value}
      onChange={onChange}
    />
  )
}
